<template>
    <div v-if="!loading && items.show_message">
        <v-alert type="info" icon="mdi-package-variant" text dense class="mb-2">
            {{ items.message }}
        </v-alert> 
    </div>
</template>

<script>
import axios from '../../plugins/axios'

export default {
    data: () => ({
        items: {},
        loading: false,
    }),
    methods: {
        getItem() {
            this.loading = true
            axios.get(`/api/office-assets/hasItemsToReturn`).then((resp) => {
                this.items = resp.data
            }).finally(() => this.loading = false)
        }
    },
    mounted() {
        this.getItem()
    },
}
</script>

<style>

</style>